import { useEffect } from "react";

/**
 * Custom hook to detect clicks outside of a referenced element
 * @param {React.RefObject} ref - Reference to the element to detect outside clicks
 * @param {Function} callback - Function to call when outside click is detected
 */
export const useClickOutside = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};
